/**
 * Lightweight global signal for "Key (the AI) is processing a turn".
 *
 * Driven by the axios interceptor that tracks in-flight POST /AI calls (see axiosUtil.js).
 * Deliberately NOT in Redux: the store chain imports axiosUtil, so dispatching from the
 * interceptor would risk a circular import. A tiny pub/sub counter also means every /AI
 * caller — chat, voice, label filter, or the headless report run — lights the indicator up
 * with no per-call wiring.
 */
let inFlight = 0;
const listeners = new Set();

function emit() {
  const busy = inFlight > 0;
  listeners.forEach((fn) => {
    try { fn(busy); } catch (e) { /* a bad listener must not break others */ }
  });
}

export const aiActivity = {
  start() { inFlight += 1; emit(); },
  stop() { inFlight = Math.max(0, inFlight - 1); emit(); },
  isBusy() { return inFlight > 0; },
  /** Subscribe to busy changes; returns an unsubscribe fn. */
  subscribe(fn) { listeners.add(fn); return () => listeners.delete(fn); },
};

export default aiActivity;
